export default "__VITE_ASSET__DJvaGGU4__"